export default "__VITE_ASSET__BfTXi$9K__"